import { render, staticRenderFns } from "./CommissionSchemaType.vue?vue&type=template&id=5d8179c7&"
import script from "./CommissionSchemaType.vue?vue&type=script&setup=true&lang=js&"
export * from "./CommissionSchemaType.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports